var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCheck = function SvgIcCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.422 2.73c.343.234.431.7.198 1.043L8.274 13.08a.75.75 0 0 1-1.173.085L2.447 8.088a.75.75 0 1 1 1.106-1.014l4.014 4.38 5.813-8.526a.75.75 0 0 1 1.042-.198Z"
  })));
};
export default SvgIcCheck;